/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
  GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams,
  GetApiV1IndividualpaymentSharedCourseRegistrations401,
  GetApiV1IndividualpaymentSharedCourseRegistrations500,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedCourseRegistrations.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentSharedCourseRegistrations } from "../../clients/individualPaymentSharedController/getApiV1IndividualpaymentSharedCourseRegistrations.ts";

export const getApiV1IndividualpaymentSharedCourseRegistrationsQueryKey = (
  params?: GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams,
) =>
  [
    { url: "/api/v1/individualpayment/shared/course-registrations" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentSharedCourseRegistrationsQueryKey =
  ReturnType<typeof getApiV1IndividualpaymentSharedCourseRegistrationsQueryKey>;

export function getApiV1IndividualpaymentSharedCourseRegistrationsQueryOptions(
  params?: GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentSharedCourseRegistrationsQueryKey(params);
  return queryOptions<
    GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedCourseRegistrations401
      | GetApiV1IndividualpaymentSharedCourseRegistrations500
    >,
    GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentSharedCourseRegistrations(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna as matrículas da pessoa com rótulo "[Turma]Curso". O parâmetro 'companyId' usa igualdade exata (null retorna apenas matrículas sem empresa), sobreposto pela empresa do usuário autenticado. Migrado do legado CourseAsync/GetCourseRegistrationsByPerson. **(Requer Authorization para autenticação)**
 * @summary Dropdown de matrículas de uma pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/shared/course-registrations}
 */
export function useGetApiV1IndividualpaymentSharedCourseRegistrations<
  TData = GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
  TQueryData = GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentSharedCourseRegistrationsQueryKey,
>(
  params?: GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentSharedCourseRegistrations401
          | GetApiV1IndividualpaymentSharedCourseRegistrations500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentSharedCourseRegistrationsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentSharedCourseRegistrationsQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedCourseRegistrations401
      | GetApiV1IndividualpaymentSharedCourseRegistrations500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
